import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../components/shared/page-layout/page-layout.component';

/**
 * Page 404.
 *
 * Remplace l'ancien `{ path: '**', redirectTo: '/' }` : rediriger chaque URL inconnue
 * vers l'accueil produisait un « soft 404 » (statut 200 sur une page sans rapport),
 * ce que Google traite comme un signal de mauvaise qualité à l'échelle du domaine.
 * On propose ici les vraies portes d'entrée plutôt qu'une impasse.
 */
@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css'
})
export class NotFoundComponent {
  title = 'Page introuvable';
  subtitle = "Cette page n'existe pas ou a été déplacée";
  heroImage = 'assets/static_pages_images/Blog.jpg';
  breadcrumbs = [{ label: 'Page introuvable' }];

  suggestions = [
    { label: 'Assurance de prêt immobilier', link: '/assurance-credit-emprunteur' },
    { label: 'Prévoyance professionnelle', link: '/assurance-prevoyance-professionnelle' },
    { label: 'Santé des professionnels', link: '/assurance-sante-professionnels' },
    { label: 'Responsabilité décennale', link: '/assurance-rc-decennale' },
    { label: 'Flotte automobile', link: '/assurance-flotte-automobile' },
    { label: 'Nous contacter', link: '/contact' }
  ];
}
